<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      title="Courriers type"
      subtitle="Gestion des courriers type pour les débiteurs"
      autocomplete_idHistory="courriers_types"
      autocomplete_field="courrier_type.nom"
      bdTable="courrier_rype"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      ref="courrier_type_resource"
      defaultOrder="nom"
      defaultSort="ASC"
      @edit_courrier_type="editCourrierType"
      @delete_courrier_type="deleteCourrierType"
    >
      <template v-slot:menu>
        <b-button icon size="sm" variant="info" @click="newCourrierType"
          ><b-icon-plus-circle-fill></b-icon-plus-circle-fill></b-button
        >
      </template>
      <template v-slot:cell(shortcut)="data">
        <span v-if="data.item.shortcut == 'yes'">oui</span>
        <span v-else>non</span>
      </template>
      <template v-slot:cell(forNego)="data">
        <span v-if="data.item.forNego == '0'">non</span>
        <span v-else>oui</span>
      </template>
    </bd-table-list>
    <b-modal
      id="modal-modifier-courrier-type"
      size="xxl"
      title="Modifier un courrier type"
      hide-footer
    >
      <CourrierType
        @change="$refs.courrier_type_resource.submitSearch(false)"
        @close="$bvModal.hide('modal-modifier-courrier-type')"
        :courrier_type_id="courrier_type_id"
      ></CourrierType>
    </b-modal>
    <b-modal
      id="modal-ajouter-courrier-type"
      size="xxl"
      title="Ajouter une nouveau courrier type"
      hide-footer
    >
      <CourrierType
        @change="$refs.courrier_type_resource.submitSearch(false)"
        @close="$bvModal.hide('modal-ajouter-courrier-type')"
        courrier_type_id="new"
      ></CourrierType>
    </b-modal>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import courrier_types from "@/services/courrier_types.js";
import CourrierType from "@/components/CourrierType";
export default {
  name: "CourrierTypes",
  components: {
    BdTableList,
    CourrierType,
  },

  data() {
    return {
      Api: courrier_types,
      courrier_type_id: null,
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Administration",
          to: { name: "administration" },
        },
        {
          text: "Courriers types",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          event: "edit_courrier_type",
          icon: "pencil-square",
          variant: "success"
        },
        {
          label: "Supprimer",
          condition: () => this.$store.getters.isSuperAdmin,
          action: (id) => this.deleteCourrierType({ ID: id }),
          icon: "x-square-fill",
          variant: "danger"
        },
      ],
      fields: [
        {
          key: "nom",
          label: "Nom",
          sortable: true,
        },
        {
          key: "doSignature",
          label: "Avec signature",
        },
        {
          key: "doEntete",
          label: "Avec entête",
          sortable: true,
        },
        {
          key: "forNego",
          label: "Accès négociateur",
          sortable: true,
        },
        {
          key: "shortcut",
          label: "Accès rapide",
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:100px",
        },
      ],
    };
  },
  methods: {
    newCourrierType() {
      this.courrier_type_id = "new";
      this.$bvModal.show("modal-ajouter-courrier-type");
    },
    editCourrierType(payload) {
      this.courrier_type_id = payload.ID;
      this.$bvModal.show("modal-modifier-courrier-type");
    },
    deleteCourrierType(payload) {
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr de vouloir supprimer ce courrier?", {
          title: "Demande de confirmation",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Oui",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            courrier_types
              .delete_courrier_type({
                courrier_type_id: payload.ID,
              })
              .then((response) => {
                if (response.data.success) {
                  this.$refs.courrier_type_resource.submitSearch(true);
                }
              });
          }
        })
        .catch(() => {
          // An error occurred
        });
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>